module.exports = "<img\r\n  class=\"image-thumbnail\"\r\n  [src]=\"src\"\r\n  (click)=\"showFullSizeImage()\"\r\n>\r\n\r\n<div\r\n  class=\"full-size-image-container\"\r\n  [@fullSizeImageVisibility]=\"fullSizeImageVisibilityState\"\r\n  (click)=\"hideFullSizeImage()\"\r\n>\r\n  <img\r\n    class=\"full-size-image\"\r\n    [src]=\"src\"\r\n  >\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/AreaImageComponent/areaImage.component.html
// module id = ./src/app/common/components/AreaImageComponent/areaImage.component.html
// module chunks = main